// extracted by mini-css-extract-plugin
export default {"articuloDiv":"Articles_articuloDiv__O7JHU"};